import { StyleSheet } from "react-native-web";
import { View, Text, Button, Image } from "tamagui";
import { XPPlatform as Platform } from "./XPPlatform.mjs";
import React from "react";
import { color } from "@my/util";
import { omit } from "lodash";
import { DropDownPickerView } from "../bento-controlled/elements/dropdowns/index.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
const ActionButton = ({
  children,
  ...props
}) => {
  return /* @__PURE__ */jsx(Button, {
    ...props,
    children
  });
};
const NextButton = ({
  onPress,
  text,
  size,
  image,
  containerStyle,
  textStyle,
  buttonStyle,
  ...others
}) => {
  const defaultContainerStyle = {
    height: 55,
    borderRadius: 10,
    backgroundColor: "#85C19D",
    justifyContent: "center",
    width: Platform.select({
      native: "100%",
      web: "90%"
    }),
    paddingHorizontal: Platform.select({
      native: "5%",
      web: "2%"
    })
  };
  const defaultTextStyle = {
    fontSize: size,
    //fontWeight: 'bold',
    color: "#fff"
  };
  const defaultButtonStyle = {
    width: 35,
    height: 37,
    backgroundColor: "#63995D",
    borderRadius: 25,
    justifyContent: "center",
    alignItems: "center"
  };
  return /* @__PURE__ */jsx(View, {
    style: StyleSheet.flatten([defaultContainerStyle, containerStyle]),
    "$platform-web": {
      paddingHorizontal: "2%"
    },
    children: /* @__PURE__ */jsxs(View, {
      style: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
      },
      children: [/* @__PURE__ */jsx(Button, {
        unstyled: true,
        "$platform-native": {
          display: "none"
        }
      }), /* @__PURE__ */jsx(Text, {
        style: StyleSheet.flatten([defaultTextStyle, textStyle]),
        children: text
      }), /* @__PURE__ */jsx(Button, {
        ...others,
        onPress,
        onLongPress: onPress,
        style: StyleSheet.flatten([defaultButtonStyle, buttonStyle]),
        children: /* @__PURE__ */jsx(Image, {
          src: image,
          style: {
            width: 18,
            height: 16
          }
        })
      })]
    })
  });
};
const borderBase = {
  borderWidth: 1,
  borderStyle: "solid"
};
const ActiveButton = ({
  ButtonTextProps,
  ...props
}) => {
  const {
    hoverStyle,
    style,
    icon,
    iconAfter,
    children: ButtonChildren,
    ...ButtonProps2
  } = props;
  const RestButtonTextProps = {
    "$group-btn-hover": {
      color: "black"
    },
    "$group-btn-press": {
      color: "black"
    },
    color: ButtonProps2.variant === "outlined" ? color.tzaGreen : "white"
  };
  if (ButtonTextProps?.["$group-btn-hover"]) {
    Object.assign(RestButtonTextProps["$group-btn-hover"], ButtonTextProps?.["$group-btn-hover"]);
    Object.assign(RestButtonTextProps["$group-btn-press"], ButtonTextProps?.["$group-btn-hover"]);
  }
  Object.assign(RestButtonTextProps, omit(ButtonTextProps, ["$group-btn-hover"]));
  const iconProps = {};
  if (icon) {
    iconProps["icon"] = React.cloneElement(icon, RestButtonTextProps);
  }
  if (iconAfter) {
    iconProps["iconAfter"] = React.cloneElement(iconAfter, RestButtonTextProps);
  }
  const [defaultStyle, defaultHoverStyle] = ButtonProps2.variant === "outlined" ? [{
    ...borderBase,
    borderColor: color.tzaGreen,
    backgroundColor: "white"
  }, {
    ...borderBase,
    borderColor: color.tzaGreen
  }] : [{
    backgroundColor: color.tzaGreen
  }, {
    ...borderBase,
    borderColor: color.tzaGreen
  }];
  const children = ButtonChildren ? ButtonChildren : RestButtonTextProps.children ? /* @__PURE__ */jsx(Button.Text, {
    ...RestButtonTextProps
  }) : void 0;
  const RestButtonProps = Object.assign({}, omit(ButtonProps2, ["variant"]), iconProps, {
    children
  });
  return /* @__PURE__ */jsx(Button, {
    ...{
      ...defaultStyle,
      ...(style || {})
    },
    hoverStyle: {
      ...defaultHoverStyle,
      ...(hoverStyle || {})
    },
    pressStyle: {
      ...defaultHoverStyle,
      ...(hoverStyle || {})
    },
    group: "btn",
    ...RestButtonProps
  });
};
const ActiveDropdown = props => {
  const {
    val,
    setVal,
    items,
    containerStyle,
    placeholder
  } = props;
  return /* @__PURE__ */jsx(DropDownPickerView, {
    setValue: setVal,
    value: val,
    items,
    className: "tza-green-dropdown",
    DropDownContainerStyle: {
      width: "100%",
      padding: 0
      /* , margin: '10px 0' */
    },
    TriggerStyle: {
      color: "white",
      padding: 0
    },
    ViewStyle: {
      padding: 0
    },
    bottomBorderColor: "white",
    ContainerStyles: [{
      padding: 0,
      height: 44,
      overflow: "hidden",
      ...borderBase,
      borderColor: color.tzaGreen,
      borderRadius: 9,
      ...(containerStyle?.[0] || {})
    }, {
      justifyContent: "flex-start",
      height: 44,
      width: "100%",
      ...(containerStyle?.[1] || {})
    }, {
      backgroundColor: "rgb(133, 193, 157)",
      height: 44,
      width: "100%",
      borderBottomWidth: 0,
      ...(containerStyle?.[2] || {})
    }],
    native: true
  });
};
export { ActionButton, ActiveButton, ActiveDropdown, NextButton };
//# sourceMappingURL=CustomButtons.mjs.map
